/* eslint-disable @typescript-eslint/indent */
import { NotificationAction } from './notification.actions'
import { NOTIFICATION_ACTION_TYPES } from './notification.constants'
import { Notification } from './notification.interface'

export const createInitialState = () => {
  const baseState: Notification = {
    available: undefined,
    registered: false,
    registering: false,
    subscribing: false,
    unsubscribing: false,
    subscribedTopics: [],
    notifications: [],
    listener: undefined,
    error: undefined
  }

  return baseState
}

const initialState = { ...createInitialState() } as Notification

function notification(state = initialState, action: NotificationAction) {
  switch (action.type) {
    case NOTIFICATION_ACTION_TYPES.SETUP_NOTIFICATION_LISTENER_SUCCESS:
      return {
        ...state,
        listener: action.object
      }
    case NOTIFICATION_ACTION_TYPES.SETUP_NOTIFICATION_LISTENER_FAILURE:
      return {
        ...state,
        listener: undefined,
        error: action.object
      }
    case NOTIFICATION_ACTION_TYPES.CHECK_NOTIFICATION_AVAILABILITY_REQUEST:
      return {
        ...state,
        available: undefined
      }
    case NOTIFICATION_ACTION_TYPES.CHECK_NOTIFICATION_AVAILABILITY_SUCCESS:
      return {
        ...state,
        available: true
      }
    case NOTIFICATION_ACTION_TYPES.CHECK_NOTIFICATION_AVAILABILITY_FAILURE:
      return {
        ...state,
        available: false
      }
    case NOTIFICATION_ACTION_TYPES.REGISTER_REMOTE_NOTIFICATION_REQUEST:
      return {
        ...state,
        registering: true
      }
    case NOTIFICATION_ACTION_TYPES.REGISTER_REMOTE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        registered: true,
        registering: false
      }
    case NOTIFICATION_ACTION_TYPES.REGISTER_REMOTE_NOTIFICATION_FAILURE:
      return {
        ...state,
        registered: false,
        registering: false,
        error: action.object
      }
    case NOTIFICATION_ACTION_TYPES.SUBSCRIBE_TO_TOPICS_REQUEST:
      return {
        ...state,
        subscribing: true
      }
    case NOTIFICATION_ACTION_TYPES.SUBSCRIBE_TO_TOPICS_SUCCESS:
      return {
        ...state,
        subscribing: false,
        subscribedTopics: [...state.subscribedTopics, ...action.object]
      }
    case NOTIFICATION_ACTION_TYPES.SUBSCRIBE_TO_TOPICS_FAILURE:
      return {
        ...state,
        subscribing: false,
        error: action.object
      }
    case NOTIFICATION_ACTION_TYPES.UNSUBSCRIBE_FROM_TOPICS_REQUEST:
      return {
        ...state,
        unsubscribing: true
      }
    case NOTIFICATION_ACTION_TYPES.UNSUBSCRIBE_FROM_TOPICS_FAILURE:
      return {
        ...state,
        unsubscribing: false,
        error: action.object
      }
    case NOTIFICATION_ACTION_TYPES.UNSUBSCRIBE_FROM_TOPICS_SUCCESS:
      return {
        ...state,
        unsubscribing: false,
        subscribedTopics: state.subscribedTopics.filter(
          (topic) => !action.object.includes(topic)
        )
      }
    default:
      return state
  }
}

export default notification
